/* src/app/shared/components/modals/copy-webquotation/copy-webquotation.component.scss */
/*# sourceMappingURL=copy-webquotation.component.css.map */
